module.exports = __webpack_public_path__ + "static/img/lifestyle_15.0d92d59b.jpg";